import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Siren, CheckCircle2, AlertTriangle } from 'lucide-react';
import { API_URL, fmtTime } from './chatShared';

export const URGENCY = {
  responder: { label: 'Responder urgente', chip: 'bg-orange-100 text-orange-800 border-orange-300', ring: 'ring-2 ring-orange-400' },
  resolver: { label: 'Resolver urgente', chip: 'bg-rose-100 text-rose-800 border-rose-300', ring: 'ring-2 ring-rose-500' },
};

// Botão no compositor: carregar alterna Normal → Responder urgente → Resolver urgente
export const UrgencyToggle = ({ value, onChange }) => {
  const next = { '': 'responder', responder: 'resolver', resolver: '' }[value || ''];
  return (
    <button type="button" onClick={() => onChange(next)} title={value ? URGENCY[value].label : 'Marcar como urgente'}
      className={`p-2 rounded-full transition-colors ${value === 'resolver' ? 'text-rose-600 bg-rose-50' : value === 'responder' ? 'text-orange-600 bg-orange-50' : 'text-slate-500 hover:text-slate-800'}`} data-testid="chat-urgency-btn">
      <Siren className="w-5 h-5" />
    </button>
  );
};

export const UrgencyBadge = ({ m, canResolve, onChanged }) => {
  if (!m.urgency) return null;
  const u = URGENCY[m.urgency];
  const resolve = () => axios.post(`${API_URL}/chat/messages/${m.id}/resolve`).then(() => { toast.success('Marcado como resolvido'); onChanged(); })
    .catch((e) => toast.error(e?.response?.data?.detail || 'Erro'));
  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-1">
      <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase rounded-full border px-1.5 py-0.5 ${m.urgent_open ? u.chip : 'bg-slate-100 text-slate-500 border-slate-200'}`} data-testid={`chat-urgency-badge-${m.id}`}>
        <AlertTriangle className="w-3 h-3" />{u.label}
      </span>
      {m.urgent_open && canResolve && (
        <button type="button" onClick={resolve} className="inline-flex items-center gap-1 text-[10px] font-bold rounded-full bg-emerald-600 text-white px-2 py-0.5 hover:bg-emerald-700" data-testid={`chat-resolve-btn-${m.id}`}>
          <CheckCircle2 className="w-3 h-3" />Resolvido
        </button>
      )}
      {!m.urgent_open && m.resolved_by && <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 rounded-full px-1.5 py-0.5" data-testid={`chat-resolved-${m.id}`}>✓ Resolvido por {m.resolved_by.split(' ')[0]} {fmtTime(m.resolved_at)}</span>}
    </div>
  );
};

export const UrgentBar = ({ msgs }) => {
  const open = msgs.filter((m) => m.urgent_open);
  if (!open.length) return null;
  return (
    <button type="button" onClick={() => document.getElementById(`chatmsg-${open[0].id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
      className="w-full flex items-center gap-2 px-4 py-2 bg-rose-50 border-b border-rose-200 text-rose-800 text-xs font-semibold text-left" data-testid="chat-urgent-bar">
      <Siren className="w-4 h-4 shrink-0 animate-pulse" />
      <span className="flex-1 truncate">{open.length} pedido(s) urgente(s) por resolver · {open[0].text || open[0].file?.name || ''}</span>
      <span className="underline shrink-0">Ver</span>
    </button>
  );
};
